import { Route, Routes } from 'react-router-dom';
import { ShareIssuesRoutes } from '../share-issues/ShareIssues';
import { WiseProgramsRoutes } from '../stock-options/wise/WisePrograms';

export const Investements = () => {
  return (
    <Routes>
      <Route path="share-issues" element={<ShareIssuesRoutes />}>
        <Route path="*" element={<ShareIssuesRoutes />} />
      </Route>
      <Route path="wise-options" element={<WiseProgramsRoutes />}>
        <Route path="*" element={<WiseProgramsRoutes />} />
      </Route>
    </Routes>
  );
};
